<script setup>
defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const layout = useLayout()
const pageId = ref(0)
const { data } = await useFetch(`/api/wagtail/pages/?slug=terms`)
pageId.value = data.value?.items?.[0]?.id || 0

function closeModal() {
  layout.showTermsAndConditions = false
}
</script>

<template>
  <transition name="modal">
    <div v-if="visible" class="modal-mask" @click="closeModal">
      <div class="modal-wrapper">
        <div class="modal-container terms" @keyup.esc="closeModal" @click.stop>
          <button class="modal-close" @click="closeModal">Close</button>
          <div class="modal-body">
            <div id="modal-upper-content" class="wa-pdp-upper">
              <section class="generic">
                <BasicBodyPage :page-id="pageId" />
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
